import React, { useState } from 'react';
import { Redirect } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';

import { LoadingAnimation } from '../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const [authSessionResult] = useState(completeAuthSession);

  if (authSessionResult.type === 'success') {
    return <LoadingAnimation />;
  }

  return <Redirect href="/account/id-me" />;
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

// Called on render, not at import: the web bundle loads every route module on any page.
function completeAuthSession() {
  return WebBrowser.maybeCompleteAuthSession();
}
